<InningNavBar />
<div class="columns is-marginless inning-scroll">
    {#each $lineups as inning, idx}
    <div class="column is-4 inning-block">
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Inning {idx + 1}
                <span class='icon is-pulled-right edit-inning'
                    on:click='set({selectedInningNum: idx, inningEditorOpen: true})'>
                    <i class='fas fa-cog'></i>
                </span>
                {#if idx + 1 < $lineups.length} <span class='icon is-pulled-right btn-spacing'
                    on:click='copyForward(idx)'>
                    <i class='fas fa-share'></i>
                    </span>
                    {/if}
                    <span class='icon is-pulled-right btn-spacing'
                        on:click='set({selectedInningNum: idx, bookmarkInningOpen: true})'>
                        <i class='far fa-star'></i>
                    </span>
            </div>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>P</span>
                {#if inning[1].last}{inning[1].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[1], 1)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[1], 1, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>C</span>
                {#if inning[2].last}{inning[2].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[2], 2)}
                    <OutOfPositionWarning />    
                {/if}
                {#if betterPlayerAvailable(inning[2], 3, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>1st</span>
                {#if inning[3].last}{inning[3].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[3], 3)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[3], 3, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>2nd</span>
                {#if inning[4].last}{inning[4].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[4], 4)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[4], 4, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>3rd</span>
                {#if inning[5].last}{inning[5].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[5], 5)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[5], 5, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>SS</span>
                {#if inning[6].last}{inning[6].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[6], 6)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[6], 6, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>LF</span>
                {#if inning[7].last}{inning[7].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[7], 7)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[7], 7, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            <p class='panel-block'>
                {#if $hasExtraFielder}
                <span class='panel-icon lineup-id'>LCF</span>
                {:else}
                <span class='panel-icon lineup-id'>CF</span>
                {/if}
                {#if inning[8].last}{inning[8].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[8], 8)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[8], 8, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            {#if $hasExtraFielder}
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>RCF</span>
                {#if inning[10] && inning[10].last}{inning[10].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[10], 10)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[10], 10, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            {/if}
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>RF</span>
                {#if inning[9].last}{inning[9].last}{:else}&nbsp;{/if}
                {#if isOutOfPosition(inning[9], 9)}
                    <OutOfPositionWarning />
                {/if}
                {#if betterPlayerAvailable(inning[9], 9, remainingPlayers(inning))}
                    <DepthChartWarning />
                {/if}
            </p>
            {#each remainingPlayers(inning) as remainingPlayer}
            <p class='panel-block has-background-grey-light has-text-light'>
                <span class='panel-icon lineup-id has-text-light'>OUT</span>
                {remainingPlayer.last}
            </p>
            {/each}
        </nav>
    </div>
    {/each}
</div>
<div class="columns is-marginless">
    <div class='column'>
    </div>
    <div class='column is-narrow'>
        <FillLineupsDialog />
        <PlayerHeatMap />
    </div>
</div>

<InningEditor bind:active=inningEditorOpen bind:inning=selectedInning bind:inningNum=selectedInningNum />
<BookmarkInning bind:active=bookmarkInningOpen bind:inning=selectedInning />

<script>
    import InningEditor from './InningEditor.html';
    import PlayerHeatMap from './PlayerHeatMap.html';
    import InningNavBar from './InningNavBar.html';
    import BookmarkInning from './BookmarkInning.html';
    import FillLineupsDialog from './FillLineupsDialog.html';
    import OutOfPositionWarning from './OutOfPositionWarning.html';
    import DepthChartWarning from './DepthChartWarning.html';

    export default {
        data() {
            return {
                currentInningNum: 0,
                inningEditorOpen: false,
                bookmarkInningOpen: false,
                selectedInningNum: 0
            };
        },
        computed: {
            selectedInning: ({ selectedInningNum, $lineups }) => $lineups[selectedInningNum],
            remainingPlayers: ({ $activeRoster, $hasExtraFielder }) => {
                return lineup => {
                    let available = [];
                    let positions = [1, 2, 3, 4, 5, 6, 7, 8, 9];
                    if ($hasExtraFielder) {
                        positions.push(10);
                    }
                    for (var playerIdx in $activeRoster) {
                        let player = $activeRoster[playerIdx];
                        let found = false;
                        for (var position of positions) {
                            let positionPlayer = lineup[position];
                            if (positionPlayer && positionPlayer.first && positionPlayer.last) {
                                if (positionPlayer.first == player.first && positionPlayer.last == player.last) {
                                    found = true;
                                }
                            }
                        }
                        if (!found) {
                            available.push(player);
                        }
                    }
                    if (available.length > $activeRoster.length - Object.keys(positions).length) {
                        return [];
                    } else {
                        return available;
                    }
                }
            },
            isOutOfPosition: ({ $depthChart, $warnOutOfPosition }) => {
                return (player, pos) => {
                    let outOfPosition = false;
                    const positionDepth = $depthChart[pos];
                    if (player.last && player.number && positionDepth && $warnOutOfPosition) {
                        outOfPosition = true;
                        positionDepth.forEach(dcPlayer => {
                            if (player.last == dcPlayer.last && player.number == dcPlayer.number) {
                                outOfPosition = false;
                            }
                        });
                    }
                    return outOfPosition;
                }
            },
            betterPlayerAvailable: ({ $depthChart, $warnDepthChartMismatch }) => {
                return (player, pos, remainingPlayers) => {
                    let betterAvailable = false;
                    const positionDepth = $depthChart[pos];
                    if (player.last && player.number && positionDepth && $warnDepthChartMismatch) {
                        let playerInDepthChart = false;
                        let playerDepthChartIdx = null;
                        positionDepth.forEach((dcPlayer, idx) => {
                            if (player.last == dcPlayer.last && player.number == dcPlayer.number) {
                                playerInDepthChart = true;
                                playerDepthChartIdx = idx;
                            }
                        });

                        remainingPlayers.forEach(remainingPlayer => {
                            positionDepth.forEach((dcPlayer, idx) => {
                                if (remainingPlayer.last == dcPlayer.last && remainingPlayer.number == dcPlayer.number) {
                                    if(idx < playerDepthChartIdx) {
                                        betterAvailable = true;
                                    }
                                }
                            });
                        });

                    }
                    return betterAvailable;
                }
            },

        },
        methods: {
            copyForward(idx) {
                const { lineups } = this.store.get();
                // quick, dirty clone
                let lineup = JSON.parse(JSON.stringify(lineups[idx]));
                lineups[idx + 1] = lineup;
                this.store.set({ lineups: lineups });
            }
        },
        components: {
            InningEditor,
            PlayerHeatMap,
            InningNavBar,
            BookmarkInning,
            FillLineupsDialog,
            OutOfPositionWarning,
            DepthChartWarning
        }
    };
</script>

<style>
    .panel-block {
        padding: 0.3em 0.75em;
        display: block;
    }

    .panel-icon {
        vertical-align: unset;
    }

    .inning-scroll {
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: mandatory;
        -webkit-scroll-snap-points-x: repeat(33%);
    }

    .inning-block {
        scroll-snap-align: start;
        -webkit-scroll-snap-align: start;
    }

    .btn-spacing {
        margin-right: 1em;
    }

    /* .heatmap-row {
        padding: 0.5rem 0.75rem;
    } */
</style>